<div class="popover {{popover_class}}" {{#if role}}role="{{role}}"{{else}}role="tooltip"{{/if}} 
{{#if focus_on_open}}tabindex="0"{{/if}} >
  <div class="arrow"></div>
  <div class="popover-title">
    <!--bootstrap will put the content here-->
  </div>
  <div class="popover-content">
    <!--bootstrap will put the content here-->
    </div>
</div>